import { render } from "./DetailsBar.vue?vue&type=template&id=470e7196&scoped=true&ts=true"
import script from "./DetailsBar.vue?vue&type=script&lang=ts"
export * from "./DetailsBar.vue?vue&type=script&lang=ts"

import "./DetailsBar.vue?vue&type=style&index=0&id=470e7196&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470e7196"]])

export default __exports__